import { render, staticRenderFns } from "./TableFolders.vue?vue&type=template&id=0137d012"
import script from "./TableFolders.vue?vue&type=script&lang=js"
export * from "./TableFolders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports